module.exports = __webpack_public_path__ + "img/p1-1.024ebb47.png";